import { useCallback, useContext } from 'react'
import { PageContext } from '../../../../../contexts/page-context'
import { useUserService } from '../../../../../lib/hooks'
import { navHelper } from '../../../../../lib/services/navigation'
import { gnarSpec } from '../../../../../lib/tracking/gnar'
import { trackGA4BtnClick } from '../../../../../lib/tracking/google-tag-manager/events'
import { goToSignUp } from '../../../../../lib/utils/navigate'
import { waitGnar } from '../../../../../lib/utils/promise'
import { composeUrl, QueryParams } from '../../../../../lib/utils/url'
import { SignUpProductRecButtonProps } from '../../types'

export enum LOW_INTENT_UTM_SOURCE {
  Youtube = 'youtube',
  GDN = 'gdn',
  GSP = 'gsp',
  GoogleDiscovery = 'googlediscovery',
}

export function useSignUpAction({
  toQueryParam,
  placement,
  placementInternalName,
}: Omit<SignUpProductRecButtonProps, 'text'>) {
  const { pageId, slug } = useContext(PageContext)
  const userService = useUserService()
  const { queryParams, url } = useSignUpProductRecUrl()

  return useCallback(async () => {
    // For the current button the internalName and targetUrl are derived from targetLink.fields property
    // Defining the properties to have their old values to not skew data/metrics for the button click
    const internalName = url

    trackGA4BtnClick(placement)
    await waitGnar(gnarSpec.customLinkCtaButtonClick(internalName, pageId, slug, url, placement, placementInternalName))

    if (toQueryParam) {
      queryParams['to'] = toQueryParam
    }

    goToSignUp(userService, { ...navHelper.currentQueryParams, ...queryParams })
  }, [pageId, placement, placementInternalName, queryParams, slug, url, userService, toQueryParam])
}

export function useSignUpProductRecUrl(): { url: string; queryParams: QueryParams } {
  const utmSource = navHelper.currentQueryParams.utm_source as LOW_INTENT_UTM_SOURCE
  const queryParams: QueryParams = Object.values(LOW_INTENT_UTM_SOURCE).includes(utmSource)
    ? { afterFirstQuestion: 'recommend' }
    : {}

  const url = composeUrl('signup', queryParams)
  return { queryParams, url }
}
